export const LUWIE_AVATAR_URL = '/media/luwie-avatar.jpg'

export type ChatMessage = {
  role: 'user' | 'assistant'
  content: string
}

export type DocSection = {
  file: string
  heading: string
  content: string
}

export type AskRequest = {
  question: string
  context: string
  history?: ChatMessage[]
}

export type AskResponse = {
  answer: string
}
